import { Loading, Maintenance, NotFound, ScreenSaver } from '@/core/blocks';
import { Route, Routes } from 'react-router-dom';
import { ROUTES, envVars } from './config';
import { useIdle } from './core';
import HomePage from './pages';
import Cups from './pages/cups';
import Competitions from './pages/cups/competitions';
import History from './pages/history';
import { PrivateRoutes } from './router';

function App() {
  const { globalLoading } = useIdle();

  if (envVars.underMaintenance) {
    return <Maintenance />;
  }

  if (globalLoading) {
    return <Loading />;
  }

  return (
    <>
      <ScreenSaver />
      <Routes>
        <Route element={<PrivateRoutes />}>
          <Route path={ROUTES.MAIN} Component={HomePage} />
          <Route path={ROUTES.HISTORY} Component={History} />
          <Route path={ROUTES.CUPS.MAIN} Component={Cups} />
          <Route path={ROUTES.CUPS.COMPETITION} Component={Competitions} />
        </Route>
        <Route
          path={ROUTES.LOGIN}
          element={<div className='h-screen flex justify-center items-center text-8xl'>Login</div>}
        />
        <Route path='*' Component={NotFound} />
      </Routes>
    </>
  );
}

export default App;
